import { useFormik } from "formik";
import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FileDisplay from "../../../utils/FileDisplay";
import { NuDate, NuInput, NuTextArea, NuUpload } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";
import { handleKeyDown, ScreenClose } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";

export default function CreateOrEdit({
  data,
  visible,
  onClose,
  refreshData,
  satusData = [],
  id,
  getCompletion = () => {},
  headerId,
  fetcherHeader=() => {},
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [selectedFile, setSelectedFile] = useState([]);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [createNew, setCreateNew] = useState({
    section_no: "",
    section: "",
    sub_section_no: "",
    sub_section: "",
    optional_sub_section_no: "",
    optional_sub_section: "",
    question_activity: "",
    user_response: "",
    user_comment: "",
    completion_date: "0000-00-00",
    reminder_date: "0000-00-00",
    status: "",
  });

  useEffect(() => {
    setCreateNew({
      section_no: headerId?.section_no || "",
      section: headerId?.section || "",
      sub_section_no: "",
      sub_section: "",
      question_activity: "",
      user_response: "",
      user_comment: "",
      completion_date: "",
      reminder_date: "",
      status: "",
    });
  }, [headerId]);

  useEffect(() => {
    setCreateNew({
      section_no: data?.section_no,
      section: data?.section,
      sub_section_no: data?.sub_section_no,
      sub_section: data?.sub_section,
      question_activity: data?.question_activity,
      user_response: data?.user_response,
      completion_date: data?.completion_date,
      user_comment: data?.user_comment,
      reminder_date: data?.reminder_date,
      status: data?.status,
    });
    if (
      data?.image_path !== null &&
      data?.image_path !== "None" &&
      data?.image_path !== "[]"
    ) {
      setFilePathList(data?.image_path);
      setRemoveFilePathList(data?.image_path);
    }
  }, [data]);

  function handleImageChange(e) {
    const files = Array.from(e.target.files);
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      if (data?.id) {
        if (removefilePathList) {
          let finalArr = removefilePathList.filter(
            (items) => !filePathList.includes(items)
          );
          value.files_to_remove = finalArr.map((item) =>
            item.replace(window.WEB_APP_API_URL, "localhost")
          );
        } else {
          value.files_to_remove = [];
        }
        let formdata = new FormData();
        if (selectedFile) {
          selectedFile.forEach((file) => {
            formdata.append("attachment_artifact", file);
          });
        } else {
          formdata.append("attachment_artifact",[]);
        }
        value.status =
          value.status !== null ? value?.status?.toLowerCase() : value?.status;
        value.completion_date =
          value.completion_date !== "None" ? value.completion_date : null;
        value.reminder_date =
          value.reminder_date !== "None" ? value.reminder_date : null;
        formdata.append("implementation_data", JSON.stringify(value));
        await ScreenClose({
          link: "implementation-checklist/implementation-list",
          id: data.id,
        });
        await editData({
          url: `/implementation-checklist/implementation-list/${data.id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          hasFile: true,
          setSelectedFile: setSelectedFile,
          otherFunction: getCompletion,
        });
      } else {
        let formdata = new FormData();
        if (selectedFile) {
          selectedFile.forEach((file) => {
            formdata.append("attachment_artifact", file);
          });
        } else {
          formdata.append("attachment_artifact",[]);
        }
        formdata.append("implementation_data", JSON.stringify(value));
        addData({
          url: `/implementation-checklist/standard/${id}/header/${headerId?.header_id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          hasFile: true,
          setSelectedFile: setSelectedFile,
          otherFunction: getCompletion,
        });
      }
      fetcherHeader()
    },
  });
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList !== item);
    setFilePathList(filterList);
  }

  const resetClose = () => {
    setSelectedFile(null);
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <NuInput
                formik={formik}
                name="section_no"
                label="Section NO."
                width="w-1/2"
                placeholder="Section NO."
                disabled={data ? true : headerId?.section_no ? true : false}
              />

              <NuInput
                formik={formik}
                name="section"
                label="Section"
                width="w-1/2"
                placeholder="Section NO."
                disabled={data ? true : headerId?.section ? true : false}
              />

              <NuInput
                formik={formik}
                name="sub_section_no"
                label="Sub-section NO."
                width="w-1/2"
                placeholder="Sub-section NO."
              />

              <NuInput
                formik={formik}
                name="sub_section"
                label="Sub-section"
                width="w-1/2"
                placeholder="Sub-section"
              />

              <NuTextArea
                formik={formik}
                name="question_activity"
                label="Questions / Activity"
                width="w-full"
                placeholder="Enter Questions / Activity"
              />

              <NuInput
                formik={formik}
                name="user_response"
                label="User Response"
                width="w-1/2"
                placeholder="User Response"
                max={25}
              />

              <NuDate
                formik={formik}
                name="completion_date"
                label="Completion Date"
                width="w-1/2"
                placeholder="Completion Date"
              />

              <NuTextArea
                formik={formik}
                name="user_comment"
                label="User Comment"
                width="w-full"
                placeholder="Enter User Comment"
              />

              <FormikSelectTwo
                formik={formik}
                name="status"
                label="Status"
                width="w-1/2"
                placeholder="Select Status"
                Options={satusData}
                zindex={12}
              />
              <NuDate
                formik={formik}
                name="reminder_date"
                label="Set Remainder Date"
                width="w-1/2"
                placeholder="Set Remainder Date"
              />
              <NuUpload
                label="Artefact"
                width="w-1/2"
                onChange={handleImageChange}
                multiple={true}
              />

              <div className=" w-full flex flex-wrap ">
                {data?.image_path && filePathList &&
                  filePathList.map((i) => {
                    return (
                      <div className=" m-1 my-3">
                        <div className=" relative">
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-bold flex justify-center items-center  -top-2 right-2 z-10"
                            onClick={() => UpdateAttachmentList(i)}
                          >
                            -
                          </div>
                          <FileDisplay
                            data={i}
                            view={true}
                            height={"45px"}
                            width={"45px"}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
